import PaperText from "../misc/PaperText";
import PaperFragment from "../misc/PaperFragment";

import CustomButton from "../input/CustomButton";

import { getLanguage } from "../../config/language/language";

/**
 * 404 page.
 */
export default function NoMatch(props) {
    return (
        <>
            <PaperText center value={getLanguage().NOT_FOUND_DESCRIPTION}/>
            <PaperText center value={<CustomButton {...props} title={getLanguage().NOT_FOUND_BUTTON} path="/home"/>}/>

            <PaperFragment center value={<img src="https://http.cat/404.jpg" alt="Page not found" width="35%"/>}/>
        </>
    );
}
